import { render } from "./UserArchive.vue?vue&type=template&id=69c1fd06&scoped=true"
import script from "./UserArchive.vue?vue&type=script&lang=js"
export * from "./UserArchive.vue?vue&type=script&lang=js"

import "./UserArchive.vue?vue&type=style&index=0&id=69c1fd06&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c1fd06"]])

export default __exports__